import { render, staticRenderFns } from "./SchoolAdmin.vue?vue&type=template&id=3bd325da&"
import script from "./SchoolAdmin.vue?vue&type=script&lang=js&"
export * from "./SchoolAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports